// Sound effects using Howler.js - lazy loaded

let Howl = null;
let sounds = {};

// Initialize Howler.js
const initHowler = async () => {
  if (!Howl) {
    const howlerModule = await import('howler');
    Howl = howlerModule.Howl;
    console.log('Howler.js loaded for sound effects');
  }
  return Howl;
};

// Create sound instances
const createSounds = async () => {
  if (Object.keys(sounds).length > 0) return sounds;
  
  await initHowler();
  
  // Create simple beep sounds using data URLs for cross-platform compatibility
  sounds = {
    use: new Howl({
      src: ['data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmcfCT2O1fPReykEKoHN8tiKOQceYbjr7KJMEQxOo+PwtWUWCUKo4vC4aiME'],
      volume: 0.3,
      rate: 1.5
    }),
    equip: new Howl({
      src: ['data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmcfCT2O1fPReykEKoHN8tiKOQceYbjr7KJMEQxOo+PwtWUdCT+a4sC5aiME'],
      volume: 0.4,
      rate: 1.0
    }),
    discard: new Howl({
      src: ['data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmcfCT2O1fPReykEKoHN8tiKOQcaYbjr7KJMEQxOo+PwtWUdCT+a4sC5aiME'],
      volume: 0.5,
      rate: 0.7
    }),
    pickup: new Howl({
      src: ['data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmcfCT2O1fPReykEKoHN8tiKOQcbYbjr7KJMEQxOo+PwtWUdCT+a4sC5aiME'],
      volume: 0.3,
      rate: 2.0
    }),
    error: new Howl({
      src: ['data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmcfCT2O1fPReykEKoHN8tiKOQcdYbjr7KJMEQxOo+PwtWUdCT+a4sC5aiME'],
      volume: 0.4,
      rate: 0.5
    })
  };
  
  return sounds;
};

// Play sound effect
export const playSound = async (soundName) => {
  try {
    // Check if sound is enabled in settings
    const playerStore = window.Alpine?.store('app');
    if (playerStore && !playerStore.settings.soundEnabled) {
      return;
    }

    await createSounds();
    
    if (sounds[soundName]) {
      sounds[soundName].play();
      console.log(`Played sound: ${soundName}`);
    } else {
      console.warn(`Sound not found: ${soundName}`);
    }
  } catch (error) {
    console.warn('Failed to play sound:', error);
  }
};

// Preload sounds
export const preloadSounds = async () => {
  try {
    await createSounds();
    console.log('Inventory sounds preloaded');
  } catch (error) {
    console.warn('Failed to preload sounds:', error);
  }
};

// Sound effect shortcuts
export const playUseSound = () => playSound('use');
export const playEquipSound = () => playSound('equip');
export const playDiscardSound = () => playSound('discard');
export const playPickupSound = () => playSound('pickup');
export const playErrorSound = () => playSound('error');